// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2275":"77def5411045fac58a6d","2771":"f1f7c61888ceec91f78a","2915":"043ccc61ca63c8bc0b74"}[chunkId] + ".js";
};